module.exports = __webpack_public_path__ + "static/media/polygon-down.16522e1a.svg";